import { requestWithMethod } from "../helpers/request";

// Obtener metadata de webhooks (tipos, entidades, operadores, etc.)
export function getWebhooksMetadata(realEstateGroupId) {
  try {
    return new Promise((resolve, reject) => {
      requestWithMethod(
        `/webhooks/metadata?realEstateGroupId=${realEstateGroupId}`,
        {
          method: "GET"
        }
      )
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// Listar todos los webhooks
export function getWebhooks() {
  try {
    return new Promise((resolve, reject) => {
      requestWithMethod("/webhooks", {
        method: "GET"
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// Obtener un webhook por ID
export function getWebhook(id) {
  try {
    return new Promise((resolve, reject) => {
      requestWithMethod(`/webhooks/${id}`, {
        method: "GET"
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// Crear un nuevo webhook
export function createWebhook(webhookData) {
  try {
    return new Promise((resolve, reject) => {
      requestWithMethod("/webhooks", {
        method: "POST",
        data: webhookData
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// Actualizar un webhook existente
export function updateWebhook(id, webhookData) {
  try {
    return new Promise((resolve, reject) => {
      requestWithMethod(`/webhooks/${id}`, {
        method: "PUT",
        data: webhookData
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// Eliminar un webhook
export function deleteWebhook(id) {
  try {
    return new Promise((resolve, reject) => {
      requestWithMethod(`/webhooks/${id}`, {
        method: "DELETE"
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// ============= WEBHOOK LOGS API =============

// Obtener logs de un webhook específico
export function getWebhookLogs(webhookId, params = {}) {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const endpoint = `/webhooks/${webhookId}/logs${
      queryParams ? `?${queryParams}` : ""
    }`;

    return new Promise((resolve, reject) => {
      requestWithMethod(endpoint, {
        method: "GET"
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// Obtener todos los logs de webhooks
export function getAllWebhookLogs(params = {}) {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const endpoint = `/webhook-logs${queryParams ? `?${queryParams}` : ""}`;

    return new Promise((resolve, reject) => {
      requestWithMethod(endpoint, {
        method: "GET"
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

// Obtener un log específico por ID
export function getWebhookLog(logId) {
  try {
    return new Promise((resolve, reject) => {
      requestWithMethod(`/webhook-logs/${logId}`, {
        method: "GET"
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    return Promise.reject(err);
  }
}
